import React from 'react';
import './gallerycomponent.css'
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const GalleryComponent = ({ items, imgStyle }) => {
  return (
    <Box sx={{ width: '100%', padding: '40px 0 30px 0' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
        {items.map((item, index) => (
          <Grid key={index} xs={item.xs} className='image__gallery-items'>
            <Item className='image__gallery-item'>
              <img style={imgStyle} className='image__gallery-img' src={item.imgSrc} alt="" />
            </Item>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GalleryComponent;
